import colors from "assets/styles/mixins/colors.scss";
import {
  MISSION_STAR_INFOS,
  MISSION_VISIBILITY_INFOS,
  MISSION_IMPACT_INFOS,
  MISSION_PHONE_INFOS,
  MISSION_COMPUTER_INFOS,
} from "constants/forms";

const COMPUTER = {
  iconTrue: "computer",
  iconFalse: "computerFalse",
  bgColor: colors.switchLightBlue,
  iconColorTrue: "light-blue",
  iconColorFalse: "blue",
  width: "22",
  height: "22",
  widthFalse: "22",
  heightFalse: "22",
  topUp: MISSION_COMPUTER_INFOS,
};

const PHONE = {
  iconTrue: "phone",
  iconFalse: "phoneFalse",
  bgColor: colors.switchLightBlue,
  iconColorTrue: "light-blue",
  iconColorFalse: "blue",
  width: "22",
  height: "22",
  widthFalse: "22",
  heightFalse: "22",
  topUp: MISSION_PHONE_INFOS,
};

const MISSION_TYPE = {
  iconTrue: "star",
  iconFalse: "classicMission",
  bgColor: colors.switchYellow,
  iconColorTrue: "yellow",
  iconColorFalse: "blue",
  width: "22",
  height: "22",
  widthFalse: "22",
  heightFalse: "22",
  topUp: MISSION_STAR_INFOS,
};
const MISSION_STATUS = {
  iconTrue: "eye",
  iconFalse: "anonymous",
  bgColor: colors.switchOrange,
  iconColorTrue: "orange",
  iconColorFalse: "blue",
  width: "22",
  height: "22",
  widthFalse: "22",
  heightFalse: "22",
  topUp: MISSION_VISIBILITY_INFOS,
};

const MISSION_IMPACT = {
  iconTrue: "leaf",
  iconFalse: "impactFalse",
  bgColor: colors.switchLightGreen,
  iconColorTrue: "green",
  iconColorFalse: "blue",
  width: "22",
  height: "22",
  widthFalse: "18",
  heightFalse: "22",
  topUp: MISSION_IMPACT_INFOS,
  href: "https://www.unicef.fr/qui-sommes-nous/objectifs-de-developpement-durable-odd/",
};

export const switchDataNames = [
  "computer",
  "telephone",
  "is_star",
  "is_visible",
  "impact",
];

export const switchDataLeft = {
  missionComputer: {
    switchData: COMPUTER,
    name: "computer",
  },
  missionPhone: {
    switchData: PHONE,
    name: "telephone",
  },
};

export const switchDataRight = {
  missionType: {
    switchData: MISSION_TYPE,
    name: "is_star",
  },
  missionStatus: {
    switchData: MISSION_STATUS,
    name: "is_visible",
  },
  missionImpact: {
    switchData: MISSION_IMPACT,
    name: "impact",
  },
};
